import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '../RichText';

// List item marker
type MarkerType = 'disc' | 'circle';

const MARKER: {
  [x in MarkerType]: {
    classNames: string;
  };
} = {
  disc: { classNames: 'list-disc' },
  circle: { classNames: 'list-circle' },
};

interface LegalListItemProps {
  readonly marker?: MarkerType;
  readonly tx?: MessageKey;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly values?: RichTranslationValues;
}

const LegalListItem = ({
  marker = 'disc',
  tx: text,
  children,
  className,
  values,
}: LegalListItemProps) => {
  const { classNames } = MARKER[marker];
  const copy = values ? (
    <RichText messageKey={text!} tValues={values} />
  ) : (
    <RichText messageKey={text!} />
  );

  return (
    <TypographyV3
      Element="li"
      className={cx('ml-4 pl-4', classNames, className)}
    >
      {copy}

      {/* Reset Typograpy for nested children */}
      {children && <TypographyV3 Element="div">{children}</TypographyV3>}
    </TypographyV3>
  );
};

export default LegalListItem;
